
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import createAxiosInstance from "../../../../utils/axiosInstance";
import { API_ENDPOINTS } from '../../../../utils/api';
import { formatDateShort, formatToUSD } from '../../../../utils/formatters';

type RecentDonationProps = {
  startIsRecentDonationLoading: () => void;
  endIsRecentDonationLoading: () => void;
};

const RecentDonation: React.FC<RecentDonationProps> = ({ startIsRecentDonationLoading, endIsRecentDonationLoading }) => {

  const axiosInstance = createAxiosInstance();
  const [recentDonationList, setRecentDonationList] = useState([]);

  useEffect(() => {
    getRecentDonation();
  }, []);

  const getRecentDonation = async () => {
    try {
      startIsRecentDonationLoading();
      const response = await axiosInstance.get(`${API_ENDPOINTS.SAFENIIGHT.GETRECENTDONATIONS}?expand=need/assessments,donor&orderBy=sequenceId+desc&limit=5&skip=0`);

      const data = response.data?.map((element: any) => ({
        id: element.sequenceId,
        date: formatDateShort(element.donationDate),
        name: `${element.firstName} ${element.lastName}`,
        mail: element.email,
        val: formatToUSD(element.donationAmount),
        referenceUrl: `/safenight/donations/donation-detail/${element?.donationId}`,
      }));

      setRecentDonationList(data);
      endIsRecentDonationLoading();
    } catch (error) {
      endIsRecentDonationLoading();
      console.log(error);
    }
  };

  return (
    <div>
      <div className="relative md:overflow-hidden md:border md:border-borderGray rounded-xl">
        <table className="table_responsive_block w-full text-xs 2xl:text-sm text-left rtl:text-right">
          <thead className="text-xs 2xl:text-sm text-gray-600 bg-gray-100 border-b">
            <tr>
              <th scope="col" className="px-4 2xl:px-6 py-3 font-medium">Donation #</th>
              <th scope="col" className="px-4 2xl:px-6 py-3 font-medium">Donation Date</th>
              <th scope="col" className="px-4 2xl:px-6 py-3 font-medium">Donor</th>
              <th scope="col" className="px-4 2xl:px-6 py-3 font-medium">Email</th>
              <th scope="col" className="px-4 2xl:px-6 py-3 font-medium">Amount</th>
            </tr>
          </thead>
          <tbody>
            {recentDonationList.map((item: any) => (
              <tr className={` border-b bg-white `} key={item.id}>
                <td data-title='Donation #' scope="row" className="px-4 2xl:px-6 py-3 font-medium text-primary cursor-pointer whitespace-nowrap">
                  <Link to={item.referenceUrl}>{item.id}</Link>
                </td>
                <td data-title='Donation Date' className="px-4 2xl:px-6 py-3">{item.date}</td>
                <td data-title='Donor' className="px-4 2xl:px-6 py-3">{item.name}</td>
                <td data-title='Email' className="px-4 2xl:px-6 py-3"><span className='truncate'>{item.mail}</span></td>
                <td data-title='Amount' className="px-4 2xl:px-6 py-3">{item.val}</td>
              </tr>
            ))}
            {recentDonationList.length === 0 && (
              <tr>
                <td colSpan={5} className="text-center py-4 text-gray-500">There are no donations.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className="mt-5 flex justify-end items-center">
        <Link to={'/safenight/donations'} className='text-secondary underline underline-offset-2 font-semibold'>View all Dontations</Link>
      </div>
    </div>
  );
};

export default RecentDonation;
